import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@/shared/lib/hooks';
import { Banner } from '@/ui';
import s from '../layouts/Layout.module.css';

/** Нет сети (ТЗ 14.3): показываем сразу над содержимым раздела. */
export function OfflineBanner() {
  const { t } = useTranslation('shell');
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div className={s.offlineBanner}>
      <Banner tone="warning" inline announce title={t('offline.title')}>
        {t('offline.description')}
      </Banner>
    </div>
  );
}
